// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1h-Z6","col":"styles_col__NrYFX"};